import { zodResolver } from '@hookform/resolvers/zod'
import { DefaultValues, useForm } from 'react-hook-form'
import { z } from 'zod'

import { makeGenericZodErrorMessage } from '@/utils/make-generic-zod-error-message'

const saveHerbicideTreatmentForm = z.object({
  treatment_name: z
    .string(makeGenericZodErrorMessage('O nome do tratamento é obrigatório.'))
    .min(3, 'O nome do tratamento é obrigatório.')
    .max(255, 'O nome do tratamento é obrigatório.'),
  herbicides: z.array(
    z.object({
      herbicide: z.object(
        {
          id: z
            .string(
              makeGenericZodErrorMessage(
                'A seleção do herbicida é obrigatória.',
              ),
            )
            .min(1, 'A seleção do herbicida é obrigatória.')
            .max(255, 'A seleção do herbicida é obrigatória.'),
          herbicide_name: z
            .string(
              makeGenericZodErrorMessage(
                'A seleção do herbicida é obrigatória.',
              ),
            )
            .min(1, 'A seleção do herbicida é obrigatória.')
            .max(255, 'A seleção do herbicida é obrigatória.'),
          supplier: z
            .string(
              makeGenericZodErrorMessage(
                'A seleção do herbicida é obrigatória.',
              ),
            )
            .min(1, 'A seleção do herbicida é obrigatória.')
            .max(255, 'A seleção do herbicida é obrigatória.'),

          registration_number: z
            .string(
              makeGenericZodErrorMessage(
                'A seleção do herbicida é obrigatória.',
              ),
            )
            .min(1, 'A seleção do herbicida é obrigatória.')
            .max(255, 'A seleção do herbicida é obrigatória.'),
        },
        makeGenericZodErrorMessage('A seleção do herbicida é obrigatória.'),
      ),
      dose: z
        .number(makeGenericZodErrorMessage('A dose do produto é obrigatória.'))
        .min(0.01, 'A dose do produto é obrigatória.'),
    }),
  ),
  treatment_cost: z
    .string(makeGenericZodErrorMessage('O custo do tratamento é obrigatório.'))
    .min(1, 'O custo do tratamento é obrigatório.')
    .transform((value) =>
      Math.round(Number(value.replace(/\./g, '').replace(/,/g, '.')) * 100),
    ),
})

export type SaveHerbicideTreatmentForm = z.infer<
  typeof saveHerbicideTreatmentForm
>

interface UseSaveHerbicideTreatmentFormProps {
  defaultValues?: DefaultValues<SaveHerbicideTreatmentForm>
}

export function useSaveHerbicideTreatmentForm({
  defaultValues,
}: UseSaveHerbicideTreatmentFormProps) {
  const form = useForm<SaveHerbicideTreatmentForm>({
    resolver: zodResolver(saveHerbicideTreatmentForm),
    defaultValues: defaultValues || {
      treatment_name: '',
      herbicides: [{}],
    },
    shouldUseNativeValidation: false,
  })

  return form
}
